export const GALLERY_CONFIG = {
  MAX_PUBLIC_PALETTES_PER_USER: 10,
  GALLERY_PAGE_SIZE: 50,
};
